import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  applyFilters: <PortalMessage id='t.app.orders.filters.applyFilters' defaultMessage='Apply Filters' />,
  title: <PortalMessage id='t.app.orders.title' defaultMessage='Order Management' />,
  filter: <PortalMessage id='t.app.orders.filters.filter' defaultMessage='Filter' />,
  export: <PortalMessage id='t.app.orders.filters.export' defaultMessage='Export' />,
  filtersTitle: <PortalMessage id='t.app.orders.filters.filtersOrders' defaultMessage='Filters Orders' />,
  exportResultTitle: (
    <PortalMessage
      id='t.app.orders.operation.popup.successMessage'
      defaultMessage='The operation was successfully completed.'
    />
  ),
  exportResultFailedTitle: (
    <PortalMessage id='t.app.orders.operation.popup.failedMessage' defaultMessage='The operation failed.' />
  ),
  exportResultDescriptionEmpty: (
    <PortalMessage
      id='t.app.orders.export.response.error.empty'
      defaultMessage='The search produced no data for export. Please change search criteria and try again.'
    />
  ),
  exportResultDescriptionExcede: (
    <PortalMessage
      id='t.app.orders.export.response.error.excede'
      defaultMessage='The search results exceed the export limit. Please refine your criteria and try again.'
    />
  ),
  close: <PortalMessage id='t.app.project.btn.close' defaultMessage='Close' />,
  errorManagement: {
    default: (
      <PortalMessage
        id='t.app.errorManagement.default'
        defaultMessage='Something went wrong. Please try again later. '
      />
    ),
    PS0022: (
      <PortalMessage id='t.app.errorManagement.PS0022' defaultMessage='Attention!The operation is not capturable.' />
    ),
    PS0026: (
      <PortalMessage
        id='t.app.errorManagement.PS0026'
        defaultMessage='Your entries are not valid. Please check your entries.'
      />
    ),
    PS0028: <PortalMessage id='t.app.errorManagement.PS0028' defaultMessage='Operation already voided' />,
    PS0052: (
      <PortalMessage
        id='t.app.errorManagement.PS0052'
        defaultMessage='Attention! TerminalId not found in the system. Please verify.'
      />
    ),
    PS0054: <PortalMessage id='t.app.errorManagement.PS0054' defaultMessage='Date inserted  is not  valid.' />
  },
  noResultsMainText: (
    <PortalMessage id='t.app.generic.noResults.mainText' defaultMessage='No results found' />
  ),
  noResultsSecondaryText: (
    <PortalMessage id='t.app.generic.noResults.secondaryText' defaultMessage='Please try again with different filter criteria' />
  )
}

export const messages = defineMessages({
  resetFilters: {
    id: 't.app.orders.filters.resetFilters',
    defaultMessage: 'Reset criteria'
  },
  pageTitle: {
    id: 't.app.orders.page.title',
    defaultMessage: 'XPay | Order Management'
  }
})

export default formattedMessage
